import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import TestPaper from '../entities/testPaper'
import Cascader from '../entities/cascader'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface TestPaperState extends ListState<TestPaper> {
    editTestPaper: TestPaper;
    cascaders: any;
    params: string;
}
class TestPaperModule extends ListModule<TestPaperState, any, TestPaper>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<TestPaper>(),
        loading: false,
        editTestPaper: new TestPaper(),
        cascaders: new Array<Cascader>(),
        params: ""
    }
    actions = {
        async getAll(context: ActionContext<TestPaperState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/TestPaper/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<TestPaper>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<TestPaperState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/TestPaper/Create', payload.data);
            return reponse.data.result
        },
        async update(context: ActionContext<TestPaperState, any>, payload: any) {
            await Ajax.put('/api/services/app/TestPaper/Update', payload.data);
        },
        async delete(context: ActionContext<TestPaperState, any>, payload: any) {
            await Ajax.delete('/api/services/app/TestPaper/Delete?Id=' + payload.data.id);
        },
        async createRandomGroup(context: ActionContext<TestPaperState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/TestPaper/CreateRandomGroup', payload.data);
            return reponse.data.result

        },
        async auditedTestPaper(context: ActionContext<TestPaperState, any>, payload: any) {
            await Ajax.post('/api/services/app/TestPaper/Review', payload.data);
        },
        async get(context: ActionContext<TestPaperState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/TestPaper/Get?Id=' + payload.data.id);
            context.state.editTestPaper = reponse.data.result as TestPaper
        },
        async getadd(context: ActionContext<TestPaperState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/TestPaper/Get?Id=' + payload.data.id);
            return reponse.data.result
        },
        async getCascader(context: ActionContext<TestPaperState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetBehindCascaderList', { params: payload.data });
            context.state.cascaders = reponse.data.result as Array<Cascader>;
            context.state.loading = false;
        },
        async showStateSwitching(context: ActionContext<TestPaperState, any>, payload: any) {
            await Ajax.post('/api/services/app/TestPaper/Activation', payload.data);
            // context.state.editTestPaper = reponse.data.result as TestPaper
        },

        async showStateSwitchingIsShow(context: ActionContext<TestPaperState, any>, payload: any) {
            await Ajax.put('/api/services/app/TestPaper/UpdateTestPaperIsShow', payload.data);
            // context.state.editTestPaper = reponse.data.result as TestPaper
        },

        async importQuestion(context: ActionContext<TestPaperState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/TestPaper/ImprotQuestionOfPaper', payload.data);
            context.state.editTestPaper = reponse.data.result as TestPaper
        },
        async importQuestionadd(context: ActionContext<TestPaperState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/TestPaper/ImprotQuestionOfPaper', payload.data);
            return reponse.data
        },
        async review(context: ActionContext<TestPaperState, any>, payload: any) {
            await Ajax.post('/api/services/app/TestPaper/Review', payload.data);
        }
    };
    mutations = {
        setCurrentPage(state: TestPaperState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: TestPaperState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: TestPaperState, testPaper: TestPaper) {
            state.editTestPaper = testPaper;
        },
        param(state: TestPaperState, params: string) {
            state.params = params;
        }
    }
}
const testPaperModule = new TestPaperModule();
export default testPaperModule;